import { showBootError } from "./lib/bootError";

// Bundled dev can move UI code into shared chunks. Load it only after this
// entry runs the React refresh preamble, and catch failures before React mounts.
// The hosted Nostreka entry reads its configuration and finishes a sign-in
// redirect first, so the router never starts on the callback URL.
void import("./nostreka/webAccess/config")
  .then(({ prepareNostrekaWebAccess }) => prepareNostrekaWebAccess())
  .then(() => import("./main"))
  .then(({ startup }) => startup)
  .catch(showBootError);
